import { render, staticRenderFns } from "./TempDoctorRegister.vue?vue&type=template&id=891a3946&scoped=true"
import script from "./TempDoctorRegister.vue?vue&type=script&lang=js"
export * from "./TempDoctorRegister.vue?vue&type=script&lang=js"
import style0 from "./TempDoctorRegister.vue?vue&type=style&index=0&id=891a3946&prod&scoped=true&lang=css"
import style1 from "./TempDoctorRegister.vue?vue&type=style&index=1&id=891a3946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891a3946",
  null
  
)

export default component.exports